// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navigation-group-section{background-color:var(--color-display);box-shadow:0px;padding:0px}.navigation-card-header{font-size:12px;letter-spacing:2px;text-transform:uppercase;white-space:nowrap}.navigation-card-text{color:var(--color-cloud-blue);font-family:var(--font-regular);padding:1px 0 0 0}.navigation-card-header{color:var(--color-cloud-blue);font-size:12px;margin:0px 6px;padding:10px 0px 4px}.navigation-card-header--disabled{color:#a9aeb6;margin:0 6px;padding:10px 0}", ""]);
// Exports
module.exports = exports;
